<template>
  <div id="wrap-header-lab">

    <div id="content-header-lab">

      <div id="lab-title">
        <div id="btn-menu">
          <img @click="menu_bar_visible=true" id="bt-logo" 
            src="/static/android-chrome-192x192.png">
        </div>
        <div id="bt-title" v-if="name=='lab'">{{user_name}}'s {{ $t("header." + name) }}</div>
        <div id="bt-title" v-else>{{ $t("header." + name) }}</div>
      </div>

      <div id="btn-account">
        <v-btn v-if="route_name=='account'"
          text color="primary" @click="$router.push({name: 'lab'})">
          <v-icon>mdi-arrow-left</v-icon>
          <div>{{ $t("account.back_to_lab") }}</div>
        </v-btn>
      <v-tooltip bottom v-if="route_name!='account'">
          <template v-slot:activator="{ on }">
            <v-btn v-on="on" depressed
              @click="showAddDocuments()">
              <v-icon>mdi-plus</v-icon>
              <v-icon>mdi-clipboard-outline</v-icon>
            </v-btn>
          </template>
          <span>{{ $t("add_documents.add_documents_to_document_clip") }}</span>
        </v-tooltip>
        <account-menu></account-menu>
      </div>

    </div>

    <!-- Modal -->

    <menu-bar
      :dialog.sync="menu_bar_visible">
    </menu-bar>

    <modal-add-documents
      :dialog.sync="add_documents_visible"
      @close="hideAddDocumentsModal()">
    </modal-add-documents>

    <modal-import-files
      :dialog.sync="import_files_visible"
      @close="hideImportFilesModal()">
    </modal-import-files>

    <modal-expired-doc-clip
      :dialog.sync="expired_doc_clip_visible">
    </modal-expired-doc-clip>

  </div>
</template>

<script>

import { mapGetters, mapMutations } from 'vuex'

export default {
  props: {
    name: {
      required: true,
      type: String,
    },
  },

  data() {
    return {
      menu_bar_visible: false,
    }
  },

  computed: {
    ...mapGetters({
      expired: 'auth/is_expired',
      expired_doc_clip_visible: 'modal/expired_doc_clip_visible',
      add_documents_visible: 'modal/add_documents_visible',
      import_files_visible: 'modal/import_files_visible',
      firstname: 'user/firstname',
      username: 'user/username',
    }),

    user_name() {
      return !!this.firstname ? this.firstname : this.username
    },

    route_name() {
      return this.$route.name
    },
  },

  methods: {
    ...mapMutations({
      showAddDocumentsModal: 'modal/showAddDocuments',
      hideAddDocumentsModal: 'modal/hideAddDocuments',
      hideImportFilesModal: 'modal/hideImportFiles',
      showExpiredDocClipModal: 'modal/showExpiredDocClip',
    }),

    showAddDocuments() {
      if (this.expired) {
        this.showExpiredDocClipModal()
      } else {
        this.showAddDocumentsModal()
        this.$analytics.logEvent('click', { name: 'project_btn_openAddDocuments' })
      }
    },
  },

}
</script>

<style scoped>

  #wrap-header-wrap {
    position: fixed;
    z-index: 1;
    background-color: #ffffff;
    min-width: 360px;
    width: inherit;
    display: flex;
    justify-content: center;
  }

  #content-header-lab {
    width: 100%;
    height: 60px;
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
  }

  #lab-title {
    display: flex;
    flex-direction: row;
    align-items: center;
  }

  #btn-menu {
    width: 70px;
    display: flex;
    justify-content: center;
    align-items: center;
  }

  #logo-wrap {
    display: flex;
    flex-direction: row;
    align-items: center;
  }

  #bt-logo {
    width: 24px;
    height: 24px;
    cursor: pointer;
    transform: translateY(1.5px);
  }

  #bt-title{
    font-family: "Bree Serif", serif;
    font-size: 16pt;
  }

  #bt-subtitle{
    font-family: "Bree Serif", serif;
    font-size: 16pt;
    margin-left: 8px;
  }

  #btn-account {
    display: flex;
    flex-direction: row;
    align-items: center;
    padding-right: 20px;
  }

  #btn-account button {
    margin-right: 20px;
  }

  .bookshelf-logo {
    fill: red;
  }

</style>



// WEBPACK FOOTER //
// src/components/shared_components/part/HeaderLab.vue